import styled from 'styled-components'

export const ExpandCollapseButton = styled.button`
  border: none;
  background-color: inherit;
  padding: 0;
  text-decoration: underline;
  color: ${(props) => props.theme.palette.primary.main};

  .far {
    border: 2px solid ${(props) => props.theme.palette.primary.main};
    border-radius: 100px;
    background-color: #fff;
    box-shadow: 0 3px 6px rgb(0 0 0 / 16%);
    padding: 16px 6px;
    margin-right: 8px;

    @media (min-width: 1200px) {
      box-shadow: none;
    }

    &::before {
      display: inline-block;
      transform: translateY(1px);
    }
  }
`
